
import React from 'react';
import {Formik, Form as FormikForm} from 'formik';
import * as yup from 'yup';
import SubmitButton from './SubmitButton';
import {TextInput, Checkbox} from '../Forms';

const key = 'linkedin';
const title = 'Get matched with job opportunities';
const subtitle = 'We can show your profile to recruiters from top companies.';


const Schema = yup.object().shape({
  jobSeeking: yup.boolean(),
  linkedin: yup.string().matches(/linkedin\.com\//, 'Must be a LinkedIn profile URL'),
});

// Opt-out: the box is checked unless the user has explicitly said no.
const getInitialJobSeeking = (profile) => profile?.data?.jobSeeking !== false;

// Records how the flag was set so downstream consumers can tell real intent
// from a passed-through default: 'explicit' when the user changed their
// answer, 'default' when a never-answered profile keeps the pre-checked box.
// An unchanged existing answer writes no source, preserving what's stored.
const buildJobSeekingUpdate = (data, jobSeeking) => {
  if (jobSeeking === data?.jobSeeking) return {jobSeeking};
  return {
    jobSeeking,
    jobSeekingSource: data?.jobSeeking == null && jobSeeking ? 'default' : 'explicit',
  };
};

const Fields = () => (
  <div className="space-y-4">
    <Checkbox
      name="jobSeeking"
      label="I'm open to new opportunities — show my profile to recruiters. You can change this anytime in your profile."
    />
    <TextInput
      name="linkedin"
      label="LinkedIn Profile URL"
      placeholder="www.linkedin.com/in/yourprofile"
    />
  </div>
);

const Form = ({incrementForm, isFinalForm, draftProfile}) => (
  <Formik
    initialValues={{
      jobSeeking: getInitialJobSeeking(draftProfile),
      linkedin: draftProfile?.data.linkedin || '',
    }}
    validationSchema={Schema}
    onSubmit={(values) => {
      incrementForm({
        data: {
          ...buildJobSeekingUpdate(draftProfile?.data, values.jobSeeking),
          ...(values.linkedin ? {linkedin: values.linkedin} : {}),
        },
      });
    }}
  >
    <FormikForm className="mt-2 w-full max-w-lg">
      <Fields />
      <SubmitButton>{isFinalForm ? 'Submit' : 'Continue'}</SubmitButton>
    </FormikForm>
  </Formik>
);

export default {
  key,
  title,
  subtitle,
  Schema,
  Fields,
  Form,
  getInitialJobSeeking,
  buildJobSeekingUpdate,
};
